export const getListCategoRegister = /* GraphQL */ `
  query getListCategoRegister {
    listCategorys(filter: { category_name: { notContains: "Premios" } }) {
      items {
        id
        category_name
      }
    }
  }
`;

export const getInfoCollect = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      require_service
      products {
        items {
          product_id {
            product_name
          }
          comments
          quantity
        }
      }
      collects {
        items {
          id
          type
          finished
          createdAt
        }
      }
    }
  }
`;

export const getCurrentOrdersMercadito = /* GraphQL */ `
  query getCurrentOrdersMercadito($id: ID!) {
    getShop(id: $id) {
      id
      deleted_at
    }
  }
`;

//get comments using id account
export const ordersByUpdatedDate = /* GraphQL */ `
  query ordersByUpdatedDate($order_type: String!, $status: String) {
    ordersByUpdatedDate(
      filter: { order_type: { notContains: $order_type } }
      sortDirection: ASC
      status: $status
      limit: 1000
    ) {
      items {
        id
        customer_id {
          id
          name
          last_name
          email
          url_photoProfile
          notification_token
          nikucoins
        }
        delivery_man_id {
          id
          name
          last_name
          delivery_transport
        }
        phase
        status
        level
        final_total
        total
        history
        propina
        discount
        products {
          items {
            price
            id
            product_id {
              product_name
              description
              price
              netcontent
              price
              offerprice
              id
            }
            quantity
            comments
            url_audio
            url_image
          }
        }
        method_pay
        address
        order_type
        order_case
        orderDetails
        shop_id {
          percentage_traded {
            value
            array_ofDiscount
          }
          acceptCard
          id
          shop_name
          availability
          status
          zone
          phone_number
          url_image
          price
          seller_id {
            id
            role
            name
            last_name
            notification_token
          }
          address_shop
          address_coords
          shop_type
        }
        require_service
        reminders
        createdAt
        updatedAt
        com_shop
        com_customer
        shop_comments
        nc
        tracking_coordinates
        shipping_fees
      }
    }
  }
`;

//get comments using id account
export const currentOrdersonTransit = /* GraphQL */ `
  query currentOrdersonTransit(
    $status: String
    $require_service: Boolean
    $level: String
    $nextToken: String
  ) {
    listOrders(
      filter: {
        status: { notContains: $status }
        require_service: { eq: $require_service }
        level: { notContains: $level }
      }
      nextToken: $nextToken
      limit: 1000
    ) {
      items {
        id
        customer_id {
          id
          name
          last_name
          email
          url_photoProfile
          notification_token
          nikucoins
        }
        delivery_man_id {
          id
          name
          last_name
          delivery_transport
        }
        phase
        status
        level
        final_total
        total
        history
        propina
        discount
        products {
          items {
            price
            id
            product_id {
              product_name
              description
              price
              netcontent
              price
              offerprice
              id
            }
            quantity
            comments
            url_audio
            url_image
          }
        }
        method_pay
        address
        order_type
        order_case
        orderDetails
        shop_id {
          percentage_traded {
            value
            array_ofDiscount
          }
          acceptCard
          id
          shop_name
          availability
          status
          zone
          phone_number
          url_image
          price
          seller_id {
            id
            role
            name
            last_name
            availability
            notification_token
          }
          address_shop
          address_coords
          shop_type
        }
        require_service
        reminders
        createdAt
        updatedAt
        com_shop
        com_customer
        shop_comments
        nc
      }
      nextToken
    }
  }
`;

/*  */

export const getHistoryOrders = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      customer_orders(
        filter: { level: { eq: "FINALIZADO" }, order_case: { ne: 5 } }
      ) {
        items {
          id
          order_type
          status
          createdAt
          require_service
          phase
          level
          shop_id {
            shop_name
          }
          shop_comments
          address
        }
      }
    }
  }
`;

export const getBirthdayClient = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      birthday
    }
  }
`;

export const getHistoryOrdersTickets = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      customer_orders(
        filter: { level: { eq: "FINALIZADO" }, order_case: { eq: 5 } }
      ) {
        items {
          id
          order_type
          status
          createdAt
          require_service
          phase
          level
          history
          shop_id {
            shop_name
          }
          products {
            items {
              product_id {
                id
                limit_ticket
                expiry_ticket
              }
            }
          }
          shop_comments
          address
        }
      }
    }
  }
`;

export const getCurrentOrders = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      customer_orders(
        filter: {
          level: { ne: "FINALIZADO" }
          status: { ne: "BASKET" }
          order_type: { ne: "PRESENCIAL" }
        }
      ) {
        items {
          id
          order_type
          status
          createdAt
          require_service
          phase
          level
          order_case
          history
          shop_id {
            shop_name
            rating
          }
          products {
            items {
              product_id {
                id
                limit_ticket
                expiry_ticket
              }
            }
          }
          shop_comments
          address
        }
      }
    }
  }
`;

export const getInfoCollectsByClient = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      customer_orders(filter: { order_type: { eq: "COLLECT" } }) {
        items {
          id
          require_service
          collects {
            items {
              id
              type
              finished
            }
          }
        }
      }
    }
  }
`;

export const getActiveTariffs = /* GraphQL */ `
  query listTariffs {
    listTariffs(filter: { status: { eq: true } }) {
      items {
        amount
        id
        status
      }
    }
  }
`;

export const getAddressByID = /* GraphQL */ `
  query getAddressByID($id: ID!) {
    getAccount(id: $id) {
      id
      user_addresses {
        items {
          id
          active
          tag
          address_id {
            id
            outdoor_number
            town
            city
            country
            street
            postal_code
            latitude
            longitude
            zip_codes
            formatted_address
          }
        }
      }
    }
  }
`;

export const getInfotoRewards = /* GraphQL */ `
  query getInfotoRewards($id: ID!) {
    getAccount(id: $id) {
      id
      nikucoins
      url_photoProfile
    }
  }
`;

export const getRewardsShop = /* GraphQL */ `
  query getRewardsShop($id: ID!, $limit: Int) {
    getShop(id: $id) {
      products(
        filter: { status: { ne: false } }
        limit: $limit
        sortDirection: ASC
      ) {
        items {
          id
          tags
          price
          product_name
          url_image
          description
          netcontent
          offerprice
        }
        nextToken
      }
    }
  }
`;

export const getRewardsShopNextToken = /* GraphQL */ `
  query getRewardsShop($id: ID!, $limit: Int, $nextToken: String) {
    getShop(id: $id) {
      products(
        filter: { status: { ne: false } }
        limit: $limit
        nextToken: $nextToken
        sortDirection: ASC
      ) {
        items {
          id
          tags
          price
          product_name
          url_image
          description
          netcontent
          offerprice
        }
        nextToken
      }
    }
  }
`;

export const getidCard = /* GraphQL */ `
  query getid($id: ID!) {
    getAccount(id: $id) {
      openPay_id
    }
  }
`;

export const getReviewsbyOrderId = /* GraphQL */ `
  query getOrder($id: ID!) {
    getOrder(id: $id) {
      reviews {
        items {
          evaluator_id {
            id
          }
          reviewEvaluated_idId
        }
      }
    }
  }
`;

export const listCategoryShops = /* GraphQL */ `
  query ListCategoryShops {
    listCategoryShops {
      items {
        shop_id {
          address_shop
          business_name
          category
          phone_number
          shop_name
        }
      }
    }
  }
`;

export const listOrders = /* GraphQL */ `
  query ListOrder {
    listOrders {
      items {
        id
      }
    }
  }
`;

export const getShopsCategos = /* GraphQL */ `
  query GetShopsCategos($id: ID!) {
    getCategory(id: $id) {
      subcategories
    }
  }
`;

export const getShopsCategos2 = /* GraphQL */ `
  query GetShopsCategos($id: ID!, $limit: Int) {
    getCategory(id: $id) {
      category_shop(limit: $limit) {
        items {
          subcategory
          shop_id {
            status
            id
            shop_name
            business_name
            address_shop
            address_coords
            phone_number
            schedule
            price
            shop_type
            description
            url_image
            url_pdf
            availability
            acceptCard
            showAddress
            seller_id {
              id
              notification_token
              user_addresses {
                items {
                  id
                  address_id {
                    latitude
                    longitude
                  }
                }
              }
            }
          }
        }
        nextToken
      }
    }
  }
`;

export const listShopsBySubcategory = /* GraphQL */ `
  query MyQuery(
    $categoryId: String
    $postal_code: [String]
    $limit: Int
    $subcategory: String
    $status: Boolean
  ) {
    getShopByCategory(
      categoryId: $categoryId
      sortDirection: ASC
      limit: $limit
      filter: { subcategory: { eq: $subcategory }, status: { eq: $status } }
      postal_code: { between: $postal_code }
    ) {
      items {
        status
        id
        shop_name
        business_name
        address_shop
        address_coords
        phone_number
        schedule
        price
        shop_type
        description
        url_image
        url_pdf
        availability
        showAddress
        postal_code
        seller_id {
          id
          notification_token
          user_addresses {
            items {
              id
              address_id {
                latitude
                longitude
              }
            }
          }
        }
        category_shop {
          items {
            subcategory
          }
        }
        subcategory
        acceptCard
        rating
      }
      nextToken
    }
  }
`;

export const list_Shops_SubcategoryNextToken = /* GraphQL */ `
  query MyQuery(
    $categoryId: String
    $postal_code: [String]
    $limit: Int
    $subcategory: String
    $status: Boolean
    $nextToken: String
  ) {
    getShopByCategory(
      categoryId: $categoryId
      sortDirection: ASC
      filter: { subcategory: { eq: $subcategory }, status: { eq: $status } }
      postal_code: { between: $postal_code }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        status
        id
        shop_name
        business_name
        address_shop
        address_coords
        phone_number
        schedule
        price
        shop_type
        description
        url_image
        url_pdf
        availability
        showAddress
        postal_code
        seller_id {
          id
          notification_token
          user_addresses {
            items {
              id
              address_id {
                latitude
                longitude
              }
            }
          }
        }
        category_shop {
          items {
            subcategory
          }
        }
        subcategory
        acceptCard
        rating
      }
      nextToken
    }
  }
`;

export const list_Shops = /* GraphQL */ `
  query MyQuery(
    $categoryId: String
    $postal_code: [String]
    $limit: Int
    $status: Boolean
  ) {
    getShopByCategory(
      categoryId: $categoryId
      sortDirection: ASC
      filter: { status: { eq: $status } }
      postal_code: { between: $postal_code }
      limit: $limit
    ) {
      items {
        status
        id
        shop_name
        business_name
        address_shop
        address_coords
        phone_number
        schedule
        price
        shop_type
        description
        url_image
        url_pdf
        availability
        showAddress
        postal_code
        seller_id {
          id
          notification_token
          user_addresses {
            items {
              id
              address_id {
                latitude
                longitude
              }
            }
          }
        }
        category_shop {
          items {
            subcategory
          }
        }
        subcategory
        acceptCard
        rating
      }
      nextToken
    }
  }
`;

export const list_Shops_NextToken = /* GraphQL */ `
  query MyQuery(
    $categoryId: String
    $postal_code: [String]
    $limit: Int
    $nextToken: String
    $status: Boolean
  ) {
    getShopByCategory(
      categoryId: $categoryId
      sortDirection: ASC
      filter: { status: { eq: $status } }
      postal_code: { between: $postal_code }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        status
        id
        shop_name
        business_name
        address_shop
        address_coords
        phone_number
        schedule
        price
        shop_type
        description
        url_image
        url_pdf
        availability
        showAddress
        postal_code
        seller_id {
          id
          notification_token
          user_addresses {
            items {
              id
              address_id {
                latitude
                longitude
              }
            }
          }
        }
        category_shop {
          items {
            subcategory
          }
        }
        subcategory
        acceptCard
      }
      nextToken
    }
  }
`;

export const listCategorys = /* GraphQL */ `
  query ListCategorys($category_name: String) {
    listCategorys(filter: { category_name: { notContains: $category_name } }) {
      items {
        id
        category_name
      }
    }
  }
`;

export const listProducts = /* GraphQL */ `
  query ListProducts($st: Boolean) {
    listProducts(filter: { status: { eq: $st } }) {
      items {
        product_name
        product_type
        status
        tags
        url_image
        price
        id
        description
        shop_id {
          id
        }
      }
    }
  }
`;

export const getUserAdresses = /* GraphQL */ `
  query GetUserAdresses($id: ID!) {
    getAccount(id: $id) {
      user_addresses {
        items {
          address_id {
            id
          }
        }
      }
    }
  }
`;

export const getRolByUser = /* GraphQL */ `
  query getRolByUser($id: ID!) {
    getAccount(id: $id) {
      id
      name
      last_name
      role
    }
  }
`;

export const getListAisles = /* GraphQL */ `
  query getListAisles {
    listCategoryShops(
      filter: { id: { eq: "ShopCate_32_miscelaneaMiMercaditodela14" } }
      limit: 5000
    ) {
      items {
        aisles
      }
    }
  }
`;

export const getShop = /* GraphQL */ `
  query GetShop($id: ID!) {
    getShop(id: $id) {
      id
      products(filter: { status: { eq: true } }, limit: 5000) {
        items {
          id
          product_name
          description
          url_image
          netcontent
          tags
          price
          offerprice
          status
          product_type
          createdAt
          updatedAt
          additional_features
          mature
        }
        nextToken
      }
    }
  }
`;

export const listProductsBySearchBar = /* GraphQL */ `
  query ProductsBySearchBar($keywords: String, $status: Boolean, $limit: Int) {
    listProducts(
      filter: { keywords: { contains: $keywords }, status: { eq: $status } }
      limit: $limit
    ) {
      items {
        id
        keywords
        status
        shop_id {
          id
          business_name
          address_shop
          address_coords
          category
          price
          shop_name
          showAddress
          status
          shop_type
          url_image
          availability
          seller_id {
            id
            notification_token
          }
          acceptCard
          rating
        }
      }
      nextToken
    }
  }
`;

export const listProductsBySearchBarNextToken = /* GraphQL */ `
  query listProductsBySearchBarNextToken(
    $keywords: String
    $status: Boolean
    $limit: Int
    $nextToken: String
  ) {
    listProducts(
      filter: { keywords: { contains: $keywords }, status: { eq: $status } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        keywords
        status
        shop_id {
          id
          business_name
          address_shop
          address_coords
          category
          price
          shop_name
          showAddress
          status
          shop_type
          url_image
          availability
          seller_id {
            id
            notification_token
          }
          acceptCard
          rating
        }
      }
      nextToken
    }
  }
`;

export const getChatsByUserId = /* GraphQL */ `
  query getChatsByUserId($id: ID!) {
    getAccount(id: $id) {
      id
      pending_chats
      chatsUser {
        items {
          chat_id {
            id
            chatsUser {
              items {
                user_id {
                  id
                  name
                  last_name
                  role
                  notification_token
                  url_photoProfile
                  shops {
                    items {
                      id
                      shop_name
                      url_image
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getUserOfaChat = /* GraphQL */ `
  query getUserOfaChat($chat_id: ID!) {
    getChat(id: $chat_id) {
      chatsUser {
        items {
          user_id {
            id
            name
            last_name
          }
        }
      }
    }
  }
`;

export const getMessagesByChat = /* GraphQL */ `
  query getMessagesByChat($chat_id: String!) {
    listMessages(filter: { chat_id: { eq: $chat_id } }) {
      items {
        id
        content
        image_url
        chat_id
        user_id {
          name
          id
        }
        createdAt
      }
    }
  }
`;

export const getNikucoins = /* GraphQL */ `
  query GetNikuCoins($id: ID!) {
    getAccount(id: $id) {
      nikucoins
    }
  }
`;

export const getCategorybyCustomer = /* GraphQL */ `
  query getCategoriesbyCustomer($id: ID!) {
    getAccount(id: $id) {
      id
      interests
      categoryUser {
        items {
          id
          category_id {
            id
            category_name
          }
        }
      }
    }
  }
`;

export const getIdSellerFromShop = /* GraphQL */ `
  query getIdSellerFromShop($shop_id: ID!) {
    getShop(id: $shop_id) {
      id
      seller_id {
        id
        notification_token
      }
    }
  }
`;

export const getBasketProduct = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      customer_orders(filter: { status: { eq: "BASKET" } }) {
        items {
          id
          order_type
          final_total
          total
          payment_id
          createdAt
          discount
          propina
          com_shop
          percentage
          com_customer
          shop_comments
          percentage
          status
          payment_id
          order_case
          shop_id {
            id
            shop_name
            percentage_traded {
              value
              array_ofDiscount
            }
            shop_type
            address_shop
            acceptCard
            schedule
            seller_id {
              id
              notification_token
            }
            rating
          }
          products {
            items {
              id
              quantity
              comments
              url_audio
              price
              additional_features
              quote_state
              product_id {
                id
                product_name
                url_image
                price
                offerprice
                product_type
                description
                limit_ticket
                expiry_ticket
                mature
              }
            }
          }
          history
        }
      }
    }
  }
`;

export const getActiveAddress = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      phone_number
      ##birthday
      customer_orders(filter: { status: { contains: "BASKET" } }) {
        items {
          id
        }
      }
      user_addresses(filter: { active: { eq: true } }) {
        items {
          address_id {
            id
            city
            country
            interior_number
            outdoor_number
            postal_code
            street
            town
            latitude
            longitude
            zip_codes
          }
          tag
        }
      }
      zip_codes
      id
    }
  }
`;

export const getOrderStatusUser = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      customer_orders(
        filter: {
          level: { notContains: "FINALIZADO" }
          order_type: { notContains: "PRESENCIAL" }
          final_total: { gt: 0 }
        }
      ) {
        items {
          id
          order_type
          shop_comments
          createdAt
          shop_id {
            shop_name
            id
          }
          products {
            items {
              id
              quantity
              comments
              url_audio
              product_id {
                id
                product_name
                url_image
                price
              }
            }
          }
          status
          level
          phase
          require_service
          payment_id
        }
      }
    }
  }
`;

export const getOrdersFromUser = /* GraphQL */ `
  query getOrdersFromUser($id: ID!) {
    getAccount(id: $id) {
      customer_orders(
        filter: {
          level: { notContains: "FINALIZADO" }
          and: { level: { notContains: "EN" } }
        }
      ) {
        items {
          id
          order_type
          shop_comments
          createdAt
          shop_id {
            shop_name
          }
          products {
            items {
              id
              quantity
              comments
              url_audio
              product_id {
                id
                product_name
                url_image
                price
              }
            }
          }
          status
          level
          require_service
        }
      }
    }
  }
`;

export const getTxtAddressActive = /* GraphQL */ `
  query GetUserAddress($id: ID!) {
    getUserAddress(id: $id) {
      address_id {
        id
        interior_number
        town
        postal_code
        city
        country
        outdoor_number
        street
        latitude
        longitude
        zip_codes
        formatted_address
      }
    }
  }
`;

export const getCurrentSession = /* GraphQL */ `
  query getCurrentSession($id: ID!) {
    getAccount(id: $id) {
      id
      current_session
    }
  }
`;

export const getIdofEspecialProduct = /* GraphQL */ `
  query GetShop($id: ID!) {
    getShop(id: $id) {
      products(filter: { product_name: { contains: "ESPECIAL" } }) {
        items {
          id
          product_name
          product_type
        }
      }
    }
  }
`;

export const getShopById = /* GraphQL */ `
  query GetShopById($id: ID!) {
    getShop(id: $id) {
      address_shop
      description
      availability
      business_name
      category
      createdAt
      deleted_at
      id
      #percentage_traded
      phone_number
      price
      schedule
      shop_name
      showAddress
      shop_type
      status
      url_image
      updatedAt
      seller_id {
        id
        notification_token
        user_addresses {
          items {
            id
            address_id {
              latitude
              longitude
            }
          }
        }
      }
      address_coords
    }
  }
`;

export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      history
      products {
        items {
          price
          product_id {
            id
            product_name
            description
            price
            product_type
            tags
            url_image
            offerprice
            netcontent
          }
          quantity
        }
      }
      final_total
      discount
      address
      id
      createdAt
      level
      method_pay
      order_type
      status
      shop_id {
        schedule
        id
        shop_name
        shop_type
        percentage_traded {
          array_ofDiscount
          value
        }
        rating
      }
    }
  }
`;

export const messageByCreationDate = /* GraphQL */ `
  query messageByCreationDate($chat_id: String!) {
    messageByCreationDate(chat_id: $chat_id, sortDirection: DESC) {
      items {
        id
        content
        image_url
        chat_id
        user_id {
          name
          id
        }
        createdAt
      }
    }
  }
`;

export const getReviewsbyEvaluated = /* GraphQL */ `
  query getReviewsbyEvaluated($reviewEvaluated_idId: String!) {
    getReviewsbyEvaluated(
      reviewEvaluated_idId: $reviewEvaluated_idId
      sortDirection: DESC
    ) {
      items {
        note
      }
    }
  }
`;

export const categoShops = /* GraphQL */ `
  query categoShops($id: ID!) {
    getAccount(id: $id) {
      email
      categoryUser {
        items {
          category_id {
            category_name
            category_shop {
              items {
                shop_id {
                  id
                  shop_name
                  business_name
                  address_shop
                  address_coords
                  showAddress
                  phone_number
                  schedule
                  price
                  shop_type
                  description
                  url_image
                  status
                  availability
                  seller_id {
                    id
                    notification_token
                    user_addresses {
                      items {
                        id
                        address_id {
                          latitude
                          longitude
                        }
                      }
                    }
                  }
                  acceptCard
                  rating
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getAccount = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      availability
      createdAt
      email
      last_name
      name
      nikucoins
      url_photoProfile
      user_addresses(filter: { active: { eq: true } }) {
        items {
          address_id {
            city
            outdoor_number
            street
            town
          }
          active
        }
      }
    }
  }
`;

export const getArrayofDiscounts = /* GraphQL */ `
  query getArrayofDiscounts($id: ID!, $for_use: Boolean, $used: Boolean) {
    getShop(id: $id) {
      discounts(filter: { for_use: { eq: $for_use }, used: { eq: $used } }) {
        items {
          id
          value
        }
      }
    }
  }
`;

export const queryFetchAddress = /* GraphQL */ `
  query queryFetchAddress($id: ID!) {
    getUserAddress(id: $id) {
      address_id {
        id
      }
    }
  }
`;

export const getTagsShop = /* GraphQL */ `
  query getTagsShop($id: ID!) {
    getShop(id: $id) {
      category_shop {
        items {
          category_id {
            tags
          }
        }
      }
    }
  }
`;

export const getTagsProductsShop = /* GraphQL */ `
  query getTagsProductsShop($id: ID!) {
    getShop(id: $id) {
      products(limit: 10000, filter: { status: { eq: true } }) {
        items {
          tags
          offerprice
          subtag
          aisle
        }
      }
    }
  }
`;

export const getDiscountArraybyShopId = /* GraphQL */ `
  query getDiscountArraybyShopId($id: ID!) {
    getShop(id: $id) {
      percentage_traded {
        id
        array_ofDiscount
      }
    }
  }
`;

export const getCurrentDiscountArraybyShopId = /* GraphQL */ `
  query getCurrentDiscountArraybyShopId($id: ID!) {
    getShop(id: $id) {
      discountsArray
      deleted_at
    }
  }
`;

export const listProductsOfTag = /* GraphQL */ `
  query listProductsOfTag($id: ID!, $tag: String, $stat: Boolean) {
    getShop(id: $id) {
      products(
        filter: { tags: { contains: $tag }, and: { status: { eq: $stat } } }
        limit: 5000
      ) {
        items {
          id
          product_name
          price
          offerprice
          netcontent
          additional_features
          product_type
          status
          tags
          url_image
          createdAt
          description
          aisle
          mature
        }
      }
    }
  }
`;

export const listProductsOfSubtag = /* GraphQL */ `
  query listProductsOfTag($id: ID!, $subtag: String, $stat: Boolean) {
    getShop(id: $id) {
      products(
        limit: 10000
        filter: {
          subtag: { contains: $subtag }
          and: { status: { eq: $stat } }
        }
      ) {
        items {
          id
          product_name
          price
          offerprice
          netcontent
          product_type
          status
          tags
          url_image
          createdAt
          description
          additional_features
          aisle
          mature
        }
      }
    }
  }
`;

export const getMyOrderDetails = /* GraphQL */ `
  query getMyOrderDetails($id: ID!) {
    getOrder(id: $id) {
      id
      customer_id {
        id
        nikucoins
      }
      canceled
      history
      order_case
      final_total
      status
      level
      method_pay
      payment_id
      address
      propina
      order_type
      discount
      com_customer
      com_shop
      delivery_man_id {
        id
        role
        name
        last_name
        notification_token
        url_photoProfile
      }
      shop_id {
        id
        shop_name
        description
        phone_number
        url_image
        showAddress
        seller_id {
          id
          name
          last_name
          notification_token
        }
        address_shop
        percentage_traded {
          value
          array_ofDiscount
        }
        rating
      }
      collects {
        items {
          id
          type
          origin_sign
          sign
          finished
          createdAt
        }
      }
      products {
        items {
          id
          price
          quantity
          additional_features
          comments
          quote_state
          product_id {
            id
            product_name
            price
            offerprice
            limit_ticket
            expiry_ticket
          }
        }
      }
      require_service
      shop_comments
      total
      percentage
      createdAt
      updatedAt
      phase
      orderDetails
    }
  }
`;

export const getProdNotUp = /* GraphQL */ `
  query getProdNotUp($tag: String) {
    listProducts(limit: 500, filter: { netcontent: { notContains: $tag } }) {
      nextToken
      items {
        id
      }
    }
  }
`;

export const fetchFavoritesShops = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      favorites {
        items {
          id
          shop_id {
            address_coords
            id
            shop_name
            status
            business_name
            address_shop
            phone_number
            schedule
            price
            shop_type
            showAddress
            description
            url_image
            availability
            url_pdf
            seller_id {
              id
              notification_token
              user_addresses {
                items {
                  id
                  address_id {
                    latitude
                    longitude
                  }
                }
              }
            }
            acceptCard
            rating
          }
        }
      }
    }
  }
`;

export const getPendingChats = /* GraphQL */ `
  query getPendingChats($id: ID!) {
    getAccount(id: $id) {
      pending_chats
    }
  }
`;

export const getNotificationTokens = /* GraphQL */ `
  query getNotificationTokens($id: ID!) {
    getAccount(id: $id) {
      notification_token
    }
  }
`;

export const getCanceledOrders = /* GraphQL */ `
  query GetAccount($id: ID!, $date: String, $shopId: String, $total: Float) {
    getAccount(id: $id) {
      customer_orders(
        filter: {
          updatedAt: { contains: $date }
          status: { eq: "CANCELADA" }
          shop_idToSort: { eq: $shopId }
          total: { eq: $total }
        }
      ) {
        items {
          id
          total
          discount
          percentage
        }
      }
    }
  }
`;

export const fetchAllTags = /* GraphQL */ `
  query listCategorys {
    listCategorys {
      items {
        id
        category_name
        tags
      }
    }
  }
`;

export const listExpoPushTokensDealers = /* GraphQL */ `
  query listExpoPushTokensDealers($role: String!) {
    listAccounts(limit: 5000, filter: { role: { eq: $role } }) {
      items {
        notification_token
      }
      nextToken
    }
  }
`;

export const listExpoPushTokensDealersNextToken = /* GraphQL */ `
  query listExpoPushTokensDealersNextToken($role: String!, $nextToken: String) {
    listAccounts(
      limit: 5000
      filter: { role: { eq: $role } }
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

export const getShopsBuyRecently = /* GraphQL */ `
  query getShopsBuyRecently($id: ID!) {
    getAccount(id: $id) {
      customer_orders(
        filter: {
          status: { eq: "FINALIZADO" }
          shop_comments: { ne: "WISHES" }
        }
        limit: 30
      ) {
        items {
          shop_id {
            address_coords
            id
            shop_name
            status
            business_name
            address_shop
            phone_number
            schedule
            price
            shop_type
            showAddress
            description
            url_image
            availability
            url_pdf
            seller_id {
              id
              notification_token
              user_addresses {
                items {
                  id
                  address_id {
                    latitude
                    longitude
                  }
                }
              }
            }
            acceptCard
            rating
          }
        }
      }
    }
  }
`;

export const getListCampigns = /* GraphQL */ `
  query getListCampigns {
    campaignsByCreationDate(
      sort_attribute: 0
      filter: { type: { eq: 0 }, status: { eq: 1 } }
      limit: 1000
    ) {
      items {
        id
        status
        url_image
        repeat_time
        start_campaign
        end_campaign
        repeat
        type
        interest
        business_list {
          id
          shop_name
        }
      }
    }
  }
`;

export const getActiveDealers = /* GraphQL */ `
  query getActiveDealers(
    $role: String
    $nextToken: String
    $limit: Int
    $date: [String]
  ) {
    listAccounts(
      filter: {
        register_approved: { eq: true }
        role: { eq: $role }
        availability: { eq: true }
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        autoassign
        name
        last_name
        current_location
        notification_token
        delivery_transport
        availability
        current_location
        levels_byAccount(filter: { status: { eq: true } }) {
          items {
            id_level {
              name
            }
          }
        }
        delivery_inprocess
        deliveryman_orders(
          filter: {
            updatedAt: { between: $date }
            level: { eq: "FINALIZADO" }
            status: { eq: "FINALIZADO" }
          } ##nextToken: $nextToken
        ) {
          items {
            id
            method_pay
            final_total
            shipping_fees
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

export const getAllDayOrders = /* GraphQL */ `
  query getAllDayOrders($id: ID!, $nextToken: String, $date: [String]) {
    getAccount(id: $id) {
      deliveryman_orders(
        filter: {
          updatedAt: { between: $date }
          level: { eq: "FINALIZADO" }
          status: { eq: "FINALIZADO" }
        }
        nextToken: $nextToken
      ) {
        items {
          id
          method_pay
          final_total
          shipping_fees
        }
        nextToken
      }
    }
  }
`;

export const getCurrenOrderbyDealerId = /* GraphQL */ `
  query getCurrenOrderbyDealerId($id: ID!) {
    getAccount(id: $id) {
      deliveryman_orders(
        filter: {
          # updatedAt: { between: $date }
          level: { ne: "FINALIZADO" }
        }
      ) {
        items {
          id
          history
          updatedAt
        }
      }
    }
  }
`;

export const getCurrentOrderByIdDealer = /* GraphQL */ `
  query getCurrentOrderByIdDealer($id: ID!, $nextToken: String) {
    getAccount(id: $id) {
      deliveryman_orders(
        filter: { level: { ne: "FINALIZADO" }, status: { ne: "FINALIZADO" } }
        nextToken: $nextToken
      ) {
        items {
          id
          customer_id {
            id
            name
            last_name
            email
            url_photoProfile
            notification_token
            nikucoins
          }
          delivery_man_id {
            id
            name
            last_name
            delivery_transport
          }
          phase
          status
          level
          final_total
          total
          history
          propina
          discount
          products {
            items {
              price
              id
              product_id {
                product_name
                description
                price
                netcontent
                price
                offerprice
                id
              }
              quantity
              comments
              url_audio
              url_image
            }
          }
          method_pay
          address
          order_type
          order_case
          orderDetails
          shop_id {
            percentage_traded {
              value
              array_ofDiscount
            }
            acceptCard
            id
            shop_name
            availability
            status
            zone
            phone_number
            url_image
            price
            seller_id {
              id
              role
              name
              last_name
              availability
              notification_token
            }
            address_shop
            address_coords
            shop_type
          }
          require_service
          reminders
          createdAt
          updatedAt
          com_shop
          com_customer
          shop_comments
          nc
        }
        nextToken
      }
    }
  }
`;
